import DetailProduct from './components/DetailProduct.vue'
import KitsDetail from './components/KitsDetail.vue'
import Home from './components/Home.vue'
import Login from './views/auth/LoginSection.vue'
import Register from './views/auth/RegisterSection.vue'
import PageNotFound from './components/layouts/PageNotFound.vue'
import CartShop from './views/guest/CartShop.vue'
import CompareProduct from './views/guest/CompareProduct.vue'
import Wishlist from './views/guest/Wishlist.vue'
import NewCheckout from './views/guest/NewCheckout.vue'

import ProfileClient from './views/auth/ProfileClient.vue'
import TrackingPcPedido from './views/auth/modal/TrackingPcPedido.vue'
import Offers from './views/guest/Offers.vue'
import FilterOffer from './views/guest/FilterOffer.vue'
import FilterSearch from './views/guest/FilterSearch.vue'
import FilterTienda from './views/guest/FilterTienda.vue'
import FilterCategorie from './views/guest/FilterCategorie.vue'
import FilterTags from './views/guest/FilterTags.vue'
import FilterMarca from './views/guest/FilterMarca.vue'
import FilterMarcaD from './views/guest/FilterMarcaD.vue'
import FilterBestSellers from './views/guest/FilterBestSellers.vue'

import ForgotPassword from './views/guest/password/ForgotPassword.vue'
import CodeOtp from './views/guest/password/Code.vue'
import ResetPassword from './views/guest/password/ResetPassword.vue'
import OrderSuccess from './views/guest/layouts/OrderSuccess.vue'

import CondicionYOferta from './views/guest/configuration/CondicionYOferta.vue'
import AvisoDeMarca from './views/guest/configuration/AvisoDeMarca.vue'
import GarantiaRMA from './views/guest/configuration/GarantiaRMA.vue'
import Privacidad from './views/guest/configuration/Privacidad.vue'
import DeliveryInfo from './views/guest/configuration/DeliveryInfo.vue'
import TerminoYCondiciones from './views/guest/configuration/TerminoYCondiciones.vue'
import TerminoYCondicionesUso from './views/guest/configuration/TerminoYCondicionesUso.vue'
import ServiciosProductos from './views/guest/configuration/ServiciosProductos.vue'
import ContactoPanel from './views/guest/configuration/ContactoPanel.vue'
import SucursalPanel from './views/guest/configuration/Sucursal.vue'
import BlogList from './views/guest/blog/BlogList.vue';
import BlogShow from './views/guest/blog/BlogShow.vue';

import CardHolder from './views/guest/CardHolder.vue'
import PcBuild from './views/pcbuild/PcBuild.vue';
import HistoriaSection from './views/guest/configuration/HistoriaSection.vue'
import ConcursosYRifas from './views/guest/configuration/ConcursosYRifas.vue'

import { createRouter, createWebHistory } from 'vue-router'
import store from './plugins/store' // <- ya no importamos jwt-decode
import OtpValidate from './components/OtpValidate.vue'
import WompiResult from './views/WompiResult.vue'


const routes = [
  { name: 'Home', component: Home, path: '/', meta: null },
  { name: 'Login', component: Login, path: '/login', meta: { requiresVisitor: true } },
  { name: 'PageNotFound', component: PageNotFound, path: '/404', meta: { requiresVisitor: true } },
  { name: 'Register', component: Register, path: '/registro', meta: { requiresVisitor: true } },
  { name: 'DetailProduct', component: DetailProduct, path: '/product/:slug', meta: { requiresVisitor: null } },
  { name: 'KitsDetail', component: KitsDetail, path: '/kits/:slug', meta: { requiresVisitor: null } },
  { name: 'CartShop', component: CartShop, path: '/cart', meta: { requiresVisitor: null } },
  { name: 'CompareProduct', component: CompareProduct, path: '/comparar-producto', meta: { requiresVisitor: null } },
  { name: 'Wishlist', component: Wishlist, path: '/lista-deseos', meta: { requiresVisitor: null } },
  { name: 'Checkout', component: NewCheckout, path: '/checkout', meta: { requiresVisitor: null } },
  { name: 'TrackingPcPedido', component: TrackingPcPedido, path: '/tracking-pedido/:uniqd', meta: { requiresVisitor: null } },
  { name: 'OfferC', component: Offers, path: '/discount', meta: { requiresVisitor: null } },
  { name: 'OfferFilter', component: FilterOffer, path: '/discount/:slug', meta: { requiresVisitor: null } },
  { name: 'ForgotPassword', component: ForgotPassword, path: '/recuperar-credenciales', meta: { requiresVisitor: true } },
  { name: 'CodeOtp', component: CodeOtp, path: '/codigo-de-recuperacion', meta: { requiresVisitor: true } },
  { name: 'ResetPassword', component: ResetPassword, path: '/reset-credenciales', meta: { requiresVisitor: true } },
  { name: 'FilterSearch', component: FilterSearch, path: '/search', meta: { requiresVisitor: null } },
  { name: 'FilterTienda', component: FilterTienda, path: '/shop', meta: { requiresVisitor: null } },
  { name: 'FilterCategorie', component: FilterCategorie, path: '/shop/categorie/:id', meta: { requiresVisitor: null } },
  { name: 'FilterTags', component: FilterTags, path: '/shop/tag', meta: { requiresVisitor: null } },
  { name: 'FilterBestSellers', component: FilterBestSellers, path: '/shop/best-sellers', meta: { requiresVisitor: null } },
  { name: 'FilterMarca', component: FilterMarca, path: '/shop/brands', meta: { requiresVisitor: null } },
  { name: 'FilterMarcaD', component: FilterMarcaD, path: '/shop/brands/:id', meta: { requiresVisitor: null } },
  { name: 'ProfileClient', component: ProfileClient, path: '/perfil-cliente', meta: { requiresAuth: null } },
  { name: 'OrderSuccess', component: OrderSuccess, path: '/orden-completa/:uniqd', meta: { requiresVisitor: null } },
  { name: 'CondicionYOferta', component: CondicionYOferta, path: '/condiciones-de-ofertas', meta: { requiresVisitor: null } },
  { name: 'AvisoDeMarca', component: AvisoDeMarca, path: '/aviso-de-marca-comercial', meta: { requiresVisitor: null } },
  { name: 'GarantiaRMA', component: GarantiaRMA, path: '/politica-de-garantia', meta: { requiresVisitor: null } },
  { name: 'Privacidad', component: Privacidad, path: '/politica-de-privacidad', meta: { requiresVisitor: null } },
  { name: 'DeliveryInfo', component: DeliveryInfo, path: '/entregas-y-envios', meta: { requiresVisitor: null } },
  { name: 'TerminoYCondiciones', component: TerminoYCondiciones, path: '/termino-y-condiciones', meta: { requiresVisitor: null } },
  { name: 'ServiciosProductos', component: ServiciosProductos, path: '/servicios-productos', meta: { requiresVisitor: null } },
  { name: 'TerminoYCondicionesUso', component: TerminoYCondicionesUso, path: '/termino-y-condiciones-de-uso', meta: { requiresVisitor: null } },
  { name: 'ConcursosYRifas', component: ConcursosYRifas, path: '/concursos-y-rifas', meta: { requiresVisitor: null } },
  { name: 'ContactoPanel', component: ContactoPanel, path: '/contactos', meta: { requiresVisitor: null } },
  { name: 'SucursalPanel', component: SucursalPanel, path: '/sucursales', meta: { requiresVisitor: null } },
  { name: 'HistoriaSection', component: HistoriaSection, path: '/historia', meta: { requiresVisitor: null } },
  { name: 'BlogList', component: BlogList, path: '/blog', meta: { requiresVisitor: null } },
  { name: 'BlogListSS', component: BlogList, path: '/blog/categoria/:categorie', meta: { requiresVisitor: null } },
  { name: 'BlogListSD', component: BlogList, path: '/blog/tag/:tag', meta: { requiresVisitor: null } },
  { name: 'BlogShow', component: BlogShow, path: '/blog/:slug', meta: { requiresVisitor: null } },
  { name: 'PcBuild', component: PcBuild, path: '/pcbuilder', meta: { requiresVisitor: null } },
  { name: 'CardHolder', component: CardHolder, path: '/card-credit', meta: { requiresVisitor: null } },
  { name: 'OtpValidate', component: OtpValidate, path: '/otp-validate', meta: { requiresVisitor: true } },
  {
  path: '/wompi-validation',
  name: 'WompiResultado',
  component: WompiResult,
  meta: { requiresVisitor: null}
},
  { path: '/:catchAll(.*)', redirect: '/404' },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Espera a que el store haga bootstrap (consulta al back con la cookie)
// antes de evaluar los meta de la ruta
router.beforeEach(async (to, from, next) => {
  if (!store.state.bootstrapped) {
    try {
      await store.dispatch('bootstrapSession')
    } catch (_) {
      // no-op
    }
  }

  const isLogged = store.getters.loggedIn

  if (to.matched.some(r => r.meta?.requiresAuth)) {
    if (!isLogged) {
      return next({ name: 'Login' })
    }
    return next()
  }

  if (to.matched.some(r => r.meta?.requiresVisitor)) {
    if (isLogged) {
      return next({ name: 'Home' })
    }
    return next()
  }
if (to.name === 'ProfileClient') {
  if (Object.keys(to.query).length) {
    store.commit('setPerfilQuery', to.query)
  } else {
    const lastQuery = store.state.perfilQuery
    if (lastQuery) {
      const sameQuery =
        Object.keys(lastQuery).every(k => to.query[k] === lastQuery[k])

      if (!sameQuery) {
        return next({
          name: 'ProfileClient',
          query: lastQuery,
          replace: true 
        })
      }
    }
  }
}
  return next()
})

export default router
